import { assets } from "./assets";
import { iconPaths } from "./icons";

export const STEPS = [
  { t: "You send inventory", d: "Book a pickup or drop-off. We receive, quality-check and barcode every unit into our warehouse." },
  { t: "We store it, SKU-level", d: "Your stock sits on tracked shelves, visible live in your dashboard down to the individual unit." },
  { t: "Orders sync in", d: "Shopify orders flow in automatically and get confirmed with the customer over WhatsApp before shipping." },
  { t: "Pick, pack & ship", d: "Same-day picking and packing, next-day delivery across Egypt through integrated couriers." },
  { t: "Delivered to the door", d: "Live tracking keeps your customer informed all the way to their doorstep." },
  { t: "Cash collected & paid out", d: "We collect cash on delivery and transfer it to your bank on your chosen schedule." },
];

export const STAGE_LABELS = ["Received", "Stored", "Confirmed", "Shipped", "Delivered", "Paid"];

export const SUPPLY_STAGES = [
  { id: "manufacturing", num: "01", name: "Manufacturing", lines: ["Factory / Production", "Purchase Order (PO)"], left: 35, top: 20, pop: "below", align: "center" },
  { id: "ecomhq", num: "02", name: "EcomHQ", lines: ["Orders & Inventory", "Products / Purchase Orders"], left: 46, top: 35, pop: "below", align: "center" },
  { id: "warehouse", num: "03", name: "Warehouse", lines: ["Receiving → Barcode", "Inventory → Pick & Pack"], left: 21, top: 52, pop: "below", align: "left" },
  { id: "fulfillment", num: "04", name: "Fulfillment", lines: ["Pick → Pack → Label", "Confirm It — Order Confirmation"], left: 46, top: 56, pop: "below", align: "center" },
  { id: "delivery", num: "05", name: "Delivery & Collection", lines: ["Delivery → Cash Collection", "Bosta · Fincart"], left: 45, top: 73, pop: "above", align: "center" },
  { id: "returns", num: "06", name: "Returns & Exchanges", lines: ["Return → Inspection", "Exchange → Restock", "Backtracking"], left: 55, top: 89, pop: "above", align: "center" },
  { id: "pos", num: "P", name: "POS Bazaars", lines: ["Physical Stores", "POS Sales → Inventory Sync", "Sell anywhere, synced everywhere"], left: 82, top: 56, pop: "below", align: "right" },
];

export const SERVICES = [
  { t: "Warehousing & Storage", d: "Secure, QC'd, shelf-tracked storage for every unit you send — organized and always accounted for.", icon: iconPaths.warehouse },
  { t: "COD Collection", d: "We collect cash on delivery from your customers and pay it out to your bank on your schedule.", icon: iconPaths.cash },
  { t: "Shopify Integration", d: "Orders and inventory sync automatically from your store — no manual entry, no drift.", icon: iconPaths.shopify },
  { t: "WhatsApp Confirmation", d: "Every order confirmed with the customer over WhatsApp before it ships — fewer returns, fewer failed deliveries.", icon: iconPaths.whatsapp },
  { t: "Returns & Exchanges", d: "Pickup, inspection and restocking handled end to end, tracked at every step.", icon: iconPaths.returns },
  { t: "Barcode / SKU Tracking", d: "Unit-level inventory visibility, live in your dashboard down to the individual item.", icon: iconPaths.barcode },
  { t: "Order Tracking Portal", d: "Branded live tracking for your customers, out of the box — they always know where their order is.", icon: iconPaths.mapPin },
  { t: "Refunds System", d: "Structured refund and exchange flows your team can trust, with a clear record for every case.", icon: iconPaths.refund },
  { t: "POS Bazaar System", d: "Sell at bazaars and pop-ups with stock and sales synced back to your inventory in real time.", icon: iconPaths.pos },
  { t: "HQ Cashflow & Finance", d: "One system for balances, cash cycles and financial health across your whole operation.", icon: iconPaths.chart },
];

export const PRODUCTS = [
  {
    name: "Self-Fulfillment",
    tagline: "Your warehouse, our system",
    who: "For in-house operations",
    desc: "Fulfillment software for brands storing in their own warehouse but missing the system to run picking, packing and dispatch.",
    price: "1,800 EGP",
    per: "/ mo",
    rev: false,
    features: ["Pick & pack workflows", "Barcode / SKU tracking", "Order & courier management", "Warehouse team roles"],
    icon: iconPaths.warehouse,
  },
  {
    name: "Backtracking",
    tagline: "Returns & exchanges, under control",
    who: "For high-return catalogs",
    desc: "A dedicated system to run returns and exchanges end to end — from the customer request all the way to restock or refund.",
    price: "1,200 EGP",
    per: "/ mo",
    rev: true,
    features: ["Return & exchange workflows", "Condition & restock tracking", "Automated refunds", "Full case history"],
    icon: iconPaths.returns,
  },
  {
    name: "POS Bazaars",
    tagline: "Sell anywhere, synced everywhere",
    who: "For pop-ups & retail",
    desc: "A point-of-sale built for bazaars and pop-ups, with stock and sales synced straight back to your central inventory.",
    price: "900 EGP",
    per: "/ mo",
    rev: false,
    features: ["Offline-ready POS", "Live stock sync", "Sales & cash reports", "Multi-location support"],
    icon: iconPaths.pos,
  },
  {
    name: "EcomHQ",
    tagline: "Your e-commerce back office",
    who: "For multi-channel brands",
    desc: "One HQ to run cashflow, finances, orders and inventory across every sales channel — the same core that powers Chainz.",
    price: "2,500 EGP",
    per: "/ mo",
    rev: true,
    features: ["Cashflow & payout tracking", "Multi-channel order management", "Live inventory & reporting", "Financial health dashboard"],
    icon: iconPaths.chart,
  },
];

export const CATEGORIES = [
  { name: "Cosmetics & Skincare", icon: iconPaths.droplet },
  { name: "Apparel & Accessories", icon: iconPaths.shirt },
  { name: "Electronics & Gadgets", icon: iconPaths.phone },
  { name: "Books & Stationery", icon: iconPaths.book },
  { name: "Supplements & Fitness", icon: iconPaths.dumbbell },
  { name: "Packaged Foods", icon: iconPaths.package },
  { name: "Home Decor", icon: iconPaths.lamp },
  { name: "Games & Toys", icon: iconPaths.gamepad },
];

export const INTEGRATIONS = [
  { name: "Shopify", img: assets.integrations.Shopify },
  { name: "Bosta", img: assets.integrations.Bosta },
  { name: "Blink", img: assets.integrations.Blink },
  { name: "Confirm It", img: assets.integrations["Confirm It"] },
  { name: "EcomHQ", img: assets.integrations.EcomHQ },
  { name: "Fincart", img: assets.integrations.Fincart },
];

export const TESTIMONIALS = [
  {
    quote: "Chainz has made a real difference in how we manage our operations. Their service is reliable, efficient, and gives us the peace of mind to focus on growing the business.",
    initial: "A",
    name: "Ahmed Atty",
    role: "Founder, UA",
    bg: "linear-gradient(160deg,#a3121d,#6b0009)",
  },
  {
    quote: "Chainz has been an excellent fulfillment partner for Juvenile Blanks. Their team is trustworthy, professional, and has made the entire process seamless by handling everything from inbound inventory to order fulfillment and final delivery. Working with them has been completely hassle-free, giving us the confidence to focus on growing our brand while knowing that our logistics operations are in good hands.",
    initial: "J",
    name: "Jonathan Gabra",
    role: "Founder, Juvenile",
    bg: "linear-gradient(160deg,#2a2f3a,#12161d)",
  },
  {
    quote: [
      "I've been working with them since before they officially launched, and seeing how much they've grown while maintaining the same level of care has been incredible. What stands out most to me is that they genuinely treat my brand and products as if they were their own.",
      "Their service is extremely seamless and detail-oriented. They handle everything from warehousing and fulfillment to coordinating with the shipping company, which takes an enormous amount of operational stress off my plate. Their accuracy is something I really trust, and I rarely feel like I need to double-check what's happening behind the scenes.",
      "They've also built very efficient systems for exchanges and returns, as well as a secondary order confirmation process where customers are contacted again before an order is dispatched. That extra step helps verify orders and ultimately improves delivery success rates.",
      "For me, the biggest value is the peace of mind. I know my stock, orders, customers, and deliveries are being handled with the same level of attention I would give them myself. They don't feel like an outsourced service, they feel like an extension of my team.",
    ],
    initial: "N",
    name: "Nourabdelhakim",
    role: "Founder of Society",
    bg: "linear-gradient(160deg,#6b6470,#3a353f)",
    featured: true,
  },
];

export const FAQS = [
  ["How fast can I start fulfilling with Chainz?", "Onboarding takes days, not weeks. Create your partner account, connect Shopify, send your first inventory batch and you're live."],
  ["How does cash collection and payout work?", "We collect cash on delivery from your customers and transfer deposited cycles to your bank on your chosen cash-out frequency — as fast as next day."],
  ["Can I use Chainz software without your fulfillment?", "Standalone software — EcomHQ, Backtracking, POS Bazaars and self-fulfillment — is coming soon. Get in touch if you'd like to be first in line."],
  ["Do you integrate with my store and couriers?", "Yes — Shopify, Bosta, Blink, Confirm It, EcomHQ and Fincart connect out of the box. Orders, inventory and confirmations stay in sync automatically."],
  ["What happens with returns and exchanges?", "We pick up, inspect and restock returns according to your policy, and the Backtracking system keeps every case tracked."],
  ["Is there a minimum or lock-in contract?", "No lock-in. Fulfillment is pay-as-you-grow, with no minimum commitment."],
];

export const ABOUT_STATS = [
  { n: "200K+", l: "Orders fulfilled", divider: "transparent" },
  { n: "50+", l: "Active brands", divider: "rgba(26,20,22,0.10)" },
  { n: "All Egypt", l: "Nationwide coverage", divider: "rgba(26,20,22,0.10)" },
];

export const TEAM = [
  { name: "Daniel Salama", role: "Chief Executive Officer", src: assets.daniel, quote: "We believe logistics should be an enabler of growth, not a barrier to it.", rev: false },
  { name: "Kareem Arafat", role: "Chief Operating Officer", src: assets.kareem, quote: "Operations is a promise you make to someone else's customer. We treat every order like it carries our own name.", rev: true },
];

export const MISSION_VISION = [
  { num: "01", label: "Our Mission", title: "Take operations off the founder's plate.", body: "Every hour a brand spends chasing couriers, counting stock or reconciling cash is an hour not spent building the brand. We run that layer end to end — storage, fulfillment, delivery and collection — with full visibility in one dashboard." },
  { num: "02", label: "Our Vision", title: "The default operating system for commerce in the region.", body: "A single system every brand can plug into, whether we hold the inventory or they do. From one warehouse in Cairo to the infrastructure that moves e-commerce across Egypt and beyond." },
];

export const VALUES = [
  { n: "01", t: "Own the outcome", d: "The order isn't done when it leaves the warehouse. It's done when it's delivered and the cash has landed." },
  { n: "02", t: "Show the numbers", d: "Every unit, every fee, every cash cycle is visible to our partners in real time. No black boxes." },
  { n: "03", t: "Build the system", d: "If we solve something twice by hand, we build it into the platform so nobody solves it again." },
  { n: "04", t: "Move at brand speed", d: "Our partners launch fast and change often. Our operations have to keep up, not slow them down." },
];

export const SMALL_ARTICLES = [
  { cat: "Playbook", date: "Jun 2026", title: "Cutting return rates with WhatsApp order confirmation" },
  { cat: "Product", date: "May 2026", title: "Inside the Chainz dashboard: built for operators" },
];

export const MARQUEE_BRANDS = [
  { text: "NOTHINGNICE", style: { fontSize: 20, fontWeight: 800, letterSpacing: "0.28em" } },
  { text: "JUVÉNILE", style: { fontFamily: "Georgia, serif", fontSize: 26, fontWeight: 700, letterSpacing: "0.06em" } },
  { text: "8TSH", style: { fontSize: 22, fontWeight: 300, letterSpacing: "0.5em" } },
  { text: "Fem.", style: { fontFamily: "Georgia, serif", fontSize: 28, fontWeight: 700, fontStyle: "italic" } },
  { text: "ZEN", style: { fontSize: 22, fontWeight: 300, letterSpacing: "0.4em" } },
  { text: "ATELIER™", style: { fontSize: 20, fontWeight: 700, letterSpacing: "0.2em" } },
];

export const CONTACT = {
  email: "customer.support@chainzsolutions.com",
  phone: "+20 122 600 9114",
  phoneTel: "+201226009114",
  address: "Warehouse (E11/4), Industrial Area, New Cairo, Cairo",
  whatsapp: "https://wa.me/201275874380",
  track: "https://tracking.chainzsolutions.com/",
  login: "https://partner.chainzsolutions.com/login",
};
